import React from "react";
import "./component_styles/Footer.css"; // ✅ Correct import path
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <>
      <footer className="footer">
        <div className="footer-overlay"></div> {/* Background Overlay */}
        <div className="footer-container">
          {/* Left Section - Pharmacy Branding */}
          <div className="footer-section brand">
            <h2>Thompson Square Pharmacy</h2>
          </div>

          {/* Middle Section - Quick Links */}
          <div className="footer-section">
            <h3>QUICK LINKS</h3>
            <ul>
              <li
                onClick={() => {
                  navigate("/");
                  window.location.reload();
                }}
              >
                Home
              </li>
              <li onClick={() => navigate("/about#about")}>About Us</li>
              <li onClick={() => navigate("/vaccination")}>Vaccinations</li>
              <li onClick={() => navigate("/prescription")}>Prescriptions</li>
              <li onClick={() => navigate("/contact")}>Contact</li>
            </ul>
          </div>

          {/* Right Section - Contact Info */}
          <div className="footer-section">
            <h3>CONTACT US</h3>
            <p>📍 9137 Derry Rd W #1, Milton, ON L9T 7Z1, Canada</p>
            <p>📞 Phone: (905) 749-9990</p>
            <p>📠 Fax: (905) 749-9001</p>
            <p>📧 thompsonsquarepharmacy@gmail.com</p>
          </div>

          {/* Clinic Hours */}
          <div className="footer-section">
            <h3>BUSINESS HOURS</h3>
            <p>🕒 Mon: 10:00 AM - 6:00 PM</p>
            <p>🕒 Tues - Thurs: 10:00 AM - 6:30 PM</p>
            <p>🕒 Fri: 10:00 AM - 6:00 PM</p>
            <p>🕒 Sat: 10:00 AM - 2:00 PM</p>
            <p>🕒 Sun: Closed</p>
          </div>
        </div>
        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p>&copy; 2024 Thompson Square Pharmacy. All rights reserved.</p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
